<template>
  <v-container
    fluid
    style="margin-top: 0%; padding: 0% 0% 0 0; min-height: calc(100vh - 58px)"
  >
    <v-row style="height: 100%;overflow: hidden; margin: 0; padding: 0; position: relative">
      <v-col cols="12" class="pa-0">
        <GlobalNav />
      </v-col>
      <v-col
        cols="12"
        class="pa-0 d-flex align-start ga-6"
      >
        <SideBar />
        <div class="w-100 pa-3 is-light-mode">
          <BreadCrumb :linksData="linksData" class="mb-4" />
          <MarketingApp />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import GlobalNav from "@/components/layout/GlobalNav.vue";
import SideBar from "@/components/layout/SideBar.vue";
import BreadCrumb from "@/components/layout/BreadCrumb.vue";
import MarketingApp from "@/components/integrations/MarketingApp.vue";

export default {
  name: "IntegrationsIndex",
  components: {
    GlobalNav,
    SideBar,
    BreadCrumb,
    MarketingApp,
  },
  data() {
    return {
      linksData: [
        { name: "Home", link: "/" },
        { name: "Integrations", link: "" },
      ],
    };
  },
  beforeCreate() {
    
  },
  methods: {},
};
</script>
